import type {AxiosInstance} from "axios";

export interface MetlDriverQueryResult {
    driverName: string
    files: {
        group: string
        fullFilePath: string
        fileName: string
    }[]
}

export interface MetlDriversApi {
    id: string
    queryDrivers(): Promise<MetlDriverQueryResult[]>
}

export function metlDriversApi(axios: AxiosInstance, id: string) {
    const baseUrl = "/drivers"
    return {
        id: id + baseUrl,
        queryDrivers: () => axios.get<MetlDriverQueryResult[]>(baseUrl).then(r => r.data)
    }
}